import { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header data-section-id="52094" id="header" data-animate className="dark font-sans sticky top-0 z-50 w-full transition-all duration-300 border border-border bg-card backdrop-blur-md rounded-lg shadow-xl p-0 md:pt-4">
      <div className="container flex items-center justify-between">
        {}
        <Link to="/HomePage" className="flex items-center shrink-0 transition-opacity hover:opacity-80">
          <img src="https://vladcotoros.md/wp-content/uploads/2026/03/logo__Varianta-orizontala-secundara-pe-fundal-inchis-1-scaled.png" alt="WebinarClon" className="object-contain !h-[100.983px] !w-[150px]" />
        </Link>

        {}
        <Link to="tel:078343777" className="btn text-sm font-bold tracking-widest">078343777</Link>
      </div>
    </header>;
}